import React from "react";
import {t} from "i18next";
import {MenuProps} from 'antd';
import {api} from "../../api/apiProvider";
import urls from "../../api/urls";
import {message} from "antd";
import Roles from "../../roles/Roles";
import {CopyBriefForm} from "./CopyBriefForm";

const archiveBrief = async (id: number) => {
  return await api.patch(`${urls.briefs}/${id}`, {
    arg: {
      isActive: false,
    }
  })
};

const unArchiveBrief = async (id: number) => {
  return await api.patch(`${urls.briefs}/${id}`, {
    arg: {
      isActive: true,
    }
  })
};

export function useListActionItems(refresh: Function) {
  const archive = (briefId: number) => {
    if (!Roles.hasAccess('canArchiveBrief')) {
      return
    }

    archiveBrief(briefId).then((response) => {
      if (response.id && response.isActive === false) {
        message.success(t('list.archivedSuccess'));
        refresh()
      }
    }).catch(errors => {
      if (errors['hydra:description']) {
        message.error(errors['hydra:description'])
      }
    })
  };

  const unArchive = (briefId: number) => {
    if (!Roles.hasAccess('canArchiveBrief')) {
      return
    }

    unArchiveBrief(briefId).then((response) => {
      if (response.id && response.isActive === true) {
        message.success(t('list.unArchivedSuccess'));
        refresh()
      }
    }).catch(errors => {
      if (errors['hydra:description']) {
        message.error(errors['hydra:description'])
      }
    })
  };

  const getActualItems = (briefId: number): MenuProps['items'] => ([
    {
      key: '1',
      label: (
        <CopyBriefForm
          briefId={briefId}
          requireKpi={true}
          title={t('list.createWithOtherKpi')}
        />
      ),
    },
    {
      key: '2',
      label: (
        <CopyBriefForm
          briefId={briefId}
          requireKpi={false}
          title={t('list.createNewVersion')}
        />
      ),
    },
    {
      key: '3',
      label: (
        <a
          onClick={(e) => {
            e.stopPropagation();
            archive(briefId)
          }}
        >
          {t('list.archiveBrief')}
        </a>
      ),
    },
  ]);

  const getNotActualItems = (briefId: number): MenuProps['items'] => ([
    {
      key: '1',
      label: (
        <a
          onClick={(e) => {
            e.stopPropagation();
            unArchive(briefId)
          }}
        >
          {t('list.unArchiveBrief')}
        </a>
      ),
    },
  ]);

  return {
    getActualItems,
    getNotActualItems,
  }
}
